<div dw-row class="login-bg">
  <div *ngIf="isPassword" class="fx-forget-title">
    忘记密码
  </div>
  <div dw-col class="login-content">
    <!-- <div class="fx_logo">
      <span>
          <img src="./assets/img/login/fx_logo_new.svg"/>
      </span>
      <span>
          <img src="./assets/img/login/fx_logo_new_text.svg"/>
      </span>
    </div> -->
    <!-- <div class="login-main-block" style="height: calc(100vh - 91px)"> -->
    <div class="login-main-block">
      <!-- <div class="fx_bg_left">
        <div class="fx_login_left_bg2"><img src="assets/img/login/fx_left_bg2.png"/></div>
        <div class="fx_login_left_icon">
          <img src="assets/img/login/left_icon.svg"/>
        </div>
      </div>
      <div class="fx_form_right"> -->
        <fx-login-block [showRemember]="true" [showLanguage]="true" [modalScope]="modalScope" (dataEvent)="receiveDataFromChild($event)"></fx-login-block>
      <!-- </div> -->

    </div>
    <!-- <div dw-row class="login-copyright-block">
      <div dw-col class="login-copyright">
        <span>© Data Systems Consulting Co., Ltd. All rights reserved.</span>
      </div>
    </div> -->
  </div>
  <!-- <div class="fx_right_background">
    <img src="assets/img/login/fx_right_bg.png" />
  </div> -->
</div>

<!-- <router-outlet></router-outlet> -->
